import { render, staticRenderFns } from "./es.vue?vue&type=template&id=576c11c7&"
import script from "./es.vue?vue&type=script&lang=js&"
export * from "./es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderBar: require('/home/lewis/actions-runner/_work/EchoWaveLunar/EchoWaveLunar/components/HeaderBar.vue').default,FooterSection: require('/home/lewis/actions-runner/_work/EchoWaveLunar/EchoWaveLunar/components/FooterSection.vue').default})
